import Vue from 'vue'
import './plugins'
import App from './App'
import router from './router'
import store from './store'
import VueI18n from 'vue-i18n'
import Systemplugin from './plugins/System'
const firebasePlugin = require('./plugins/firebase').default
const {db} = require('./plugins/firebase')
const VueAnalytics = require('vue-analytics').default
Vue.use(Systemplugin)
Vue.use(VueAnalytics, { id: 'UA-112418656-10' })
Vue.use(firebasePlugin)
Vue.use(VueI18n)
Vue.use(require('./plugins/EventBus').default)
Vue.config.productionTip = false
db.ref('/System/i18n').once('value').then(dataSnap => {
  if (dataSnap.exists()) {
    const messages = dataSnap.val()
    const i18n = new VueI18n({
      locale: 'es', // set locale
      messages, // set locale messages
    })
    new Vue({
      i18n,
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
})
